import { jsx as _jsx } from "react/jsx-runtime";
import BreadcrumbDivider from './breadcrumb-divider';
import { StyledBreadcrumbs } from './styles';
import useBreadcrumbRender from './use-breadcrumb-render';
const BreadcrumbsContent = ({ breadcrumbs, size = 'medium', }) => {
    const breadcrumbRender = useBreadcrumbRender();
    return (_jsx("div", { style: { overflow: 'hidden' }, children: _jsx(StyledBreadcrumbs, { "$size": size, style: { width: '100%' }, separator: _jsx(BreadcrumbDivider, {}), items: breadcrumbs, itemRender: breadcrumbRender }) }));
};
export default BreadcrumbsContent;
